module.exports = __webpack_public_path__ + "static/img/1002_small.70b0d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1002_small.png
// module id = XC5L
// module chunks = 1